/** Client-side wa.me link (mirrors server/src/utils/whatsapp.js) */
export function buildWhatsAppUrl(number, message = '') {
  const digits = String(number || '').replace(/\D/g, '');
  if (!digits) return '';

  const base = `https://wa.me/${digits}`;
  const text = String(message || '').trim();
  if (!text) return base;

  return `${base}?text=${encodeURIComponent(text)}`;
}

/** Draft message for cart checkout — default greeting + bag lines + optional note */
export function buildCartWhatsAppMessage(whatsapp, items, contact = {}) {
  const parts = [];
  if (whatsapp?.defaultMessage) parts.push(whatsapp.defaultMessage);

  if (items?.length) {
    parts.push('\nMy cart:');
    items.forEach((item) => {
      const p = item.product || {};
      const qty = item.quantity || 1;
      const size = item.size ? ` · Size ${item.size}` : '';
      const price = Number(p.sellingPrice || 0).toLocaleString('en-IN');
      parts.push(`• ${p.title || 'Item'} × ${qty}${size} · ₹${price}`);
    });
  }

  if (contact.message?.trim()) parts.push(`\n${contact.message.trim()}`);

  const name = [contact.firstName, contact.lastName].filter(Boolean).join(' ').trim();
  if (name) parts.push(`\n— ${name}`);
  if (contact.phone?.trim()) parts.push(`Phone: ${contact.phone.trim()}`);

  return parts.join('\n').trim();
}

/** Format env phone for display, e.g. 919876543210 → +91 98765 43210 */
export function formatPhoneDisplay(number) {
  const digits = String(number || '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) {
    return `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
  }
  return String(number || '').trim();
}

export default buildWhatsAppUrl;
